import qs from 'qs';

import { INSTANT_TAX_CREDIT_HOW_IT_WORKS, route } from '../instant-tax-credit-funnel/routes/routes';

export type CalendlyUser = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

export interface GetRecurringChildcareCalendlyUrlFunc {
  (user: CalendlyUser): string;
}

export const getRecurringChildcareCalendlyUrl: GetRecurringChildcareCalendlyUrlFunc = ({
  firstName,
  lastName,
  email,
  phone,
}) => {
  const params = qs.stringify({ name: `${firstName} ${lastName}`, email, a1: phone });
  return `https://calendly.com/wecasa/presentation-garde-d-enfants-wecasa/?${params}`;
};

export const getRecurringChildcareZohoUrl = (zoho_name: string) =>
  `https://survey.zohopublic.com/zs/VACNXc?zoho_name=${zoho_name}`;

export const getOrderRecurringChildcareModificationZohoUrl = (orderZohoId: string) =>
  `https://survey.zohopublic.com/zs/1OEXS8?fromservice=ZCRM&zs_salesorders=${orderZohoId}`;

type GetInstantTaxCreditFunnelUrlParams = {
  siteUrl: string;
  searchParams: {
    potential_public_id: string;
    skip_intro_screen?: boolean;
  };
};

export const getInstantTaxCreditFunnelUrl = ({ siteUrl, searchParams }: GetInstantTaxCreditFunnelUrlParams) =>
  `${siteUrl}mon-compte/credit-impot-instantane${route(INSTANT_TAX_CREDIT_HOW_IT_WORKS)}?${new URLSearchParams({
    ...searchParams,
    skip_intro_screen: String(!!searchParams.skip_intro_screen),
  }).toString()}`;
